import React, { useState } from 'react'
import styles from '../../Examples.module.css'

const ExampleCard = ({ title, desc, url, img }) => (
  <div className={styles.example}>
    <a href={url} target="_blank" rel="noreferrer">
      <img alt="screenshot" className={styles.exampleImg} src={`/assets/img/examples/${img}`} />
    </a>
    <div className="text-start">
      <div className="text-start">
        <a className="text-decoration-none" href={url} target="_blank" rel="noreferrer">
          <h2 className="font-18 bold mt-4 color-purple">{title}</h2>
        </a>
        <div className={`${styles.exampleDesc} light-grey`}>{desc}</div>
      </div>
    </div>
  </div>
)

function getInitialTab(path) {
  if (!path.includes('/examples')) {
    return undefined
  }

  const subPath = path.split('/').pop()
  return !!!subPath || subPath === 'examples' ? 'sales-marketing' : subPath
}

const ExamplesGrid = ({ examples, history }) => {
  const [active, setActive] = useState(getInitialTab(history.location.pathname) || 'sales-marketing')
  const isExamplesPage = history?.location?.pathname?.includes('/examples')

  const onTabSelected = (slug) => {
    setActive(slug)

    if (isExamplesPage) {
      history.push(`/examples/${slug}`)
    }
  }

  return (
    <>
      <div className={styles.tabsContainer}>
        {examples.map((useCase, i) => (
          <button
            className={`${styles.tab} ${useCase.slug === active ? styles.activeTab : ''}`}
            onClick={() => onTabSelected(useCase.slug)}
            key={i}
          >
            <img
              className={`${useCase.slug === active ? styles.whiteFilter : ''} me-2 mb-1 opacity-50`}
              src={useCase.icon}
              height={15}
            />
            {useCase.label}
          </button>
        ))}
      </div>
      <div className="flex flex-wrap align-items-center justify-content-center">
        {examples
          ?.find((t) => t.slug === active)
          ?.examples.slice(0, isExamplesPage ? undefined : 3)
          .map(({ title, url, desc, img }, i) => (
            <ExampleCard key={i} title={title} url={url} desc={desc} img={img} />
          ))}
      </div>
    </>
  )
}

export default ExamplesGrid
